import React, { useEffect, useState, useRef } from "react";
import { HiX } from "react-icons/hi";
import Links from "./components/Links";
import routes from "routes.js";
import { supabase } from "lib/supabaseClient";

const Sidebar = ({ open, onClose }) => {
  const [userPermissions, setUserPermissions] = useState(() => {
    try {
      const s = sessionStorage.getItem("core_user_permissions");
      if (s) return JSON.parse(s);
      const l = localStorage.getItem("core_user_permissions");
      return l ? JSON.parse(l) : null;
    } catch {
      return null;
    }
  });
  const [userRole, setUserRole] = useState(() => {
    try {
      const s = sessionStorage.getItem("core_user_role");
      if (s) return s;
      const l = localStorage.getItem("core_user_role");
      return l || null;
    } catch {
      return null;
    }
  });
  const channelRef = useRef(null);

  // جلب صلاحيات المستخدم الحالي
  useEffect(() => {
    const fetchCurrentPermissions = async () => {
      try {
        const {
          data: { user },
        } = await supabase.auth.getUser();
        if (user) {
          const { data, error } = await supabase
            .from("employees")
            .select("permissions, role")
            .eq("id", user.id)
            .single();
          if (!error && data) {
            setUserPermissions(data.permissions);
            setUserRole(data.role);
            try {
              sessionStorage.setItem(
                "core_user_permissions",
                JSON.stringify(data.permissions || null)
              );
              localStorage.setItem(
                "core_user_permissions",
                JSON.stringify(data.permissions || null)
              );
              if (data.role) {
                sessionStorage.setItem("core_user_role", data.role);
                localStorage.setItem("core_user_role", data.role);
              }
            } catch {}
          }
          if (channelRef.current) supabase.removeChannel(channelRef.current);
          channelRef.current = supabase
            .channel(`permissions-live-${user.id}`)
            .on(
              "postgres_changes",
              {
                event: "UPDATE",
                schema: "public",
                table: "employees",
                filter: `id=eq.${user.id}`,
              },
              (payload) => {
                const row = payload.new;
                if (!row) return;
                setUserPermissions(row.permissions);
                setUserRole(row.role);
                try {
                  sessionStorage.setItem(
                    "core_user_permissions",
                    JSON.stringify(row.permissions || null)
                  );
                  localStorage.setItem(
                    "core_user_permissions",
                    JSON.stringify(row.permissions || null)
                  );
                  if (row.role) {
                    sessionStorage.setItem("core_user_role", row.role);
                    localStorage.setItem("core_user_role", row.role);
                  }
                } catch {}
              }
            )
            .subscribe();
        }
      } catch (err) {
        console.error("Permission Fetch Error:", err);
      }
    };
    fetchCurrentPermissions();
    return () => {
      if (channelRef.current) supabase.removeChannel(channelRef.current);
    };
  }, []);

  return (
    /*
     * ONLY CHANGE from original: className uses "sidebar-fixed" instead of
     * the old fixed/translate Tailwind classes. The CSS in AdminLayout locks
     * width=300px on desktop with zero transition. data-open drives mobile slide.
     * ALL inner JSX below is 100% identical to the original design.
     */
    <div
      className="sidebar-fixed bg-core-oxford pb-10 shadow-[20px_0_50px_rgba(0,0,0,0.1)] print:hidden"
      data-open={open ? "true" : "false"}
      style={{
        fontFamily: "'Kufam', sans-serif",
        touchAction: "none",
      }}
    >
      {/* إضاءة علوية خفيفة */}
      <div className="pointer-events-none absolute left-0 top-0 h-64 w-full bg-gradient-to-b from-white/5 to-transparent" />

      {/* زر الإغلاق للجوال */}
      <span
        className="absolute right-4 top-4 z-[120] block cursor-pointer p-2 text-white/50 transition-colors hover:text-white xl:hidden"
        onClick={onClose}
      >
        <HiX className="h-6 w-6" />
      </span>

      {/* الشعار */}
      <div className="relative z-10 flex flex-col items-center justify-center py-12">
        <div className="group relative cursor-default">
          <div className="relative flex items-center tracking-[0.2em]">
            <span className="text-[24px] font-extralight text-white">
              CORE
            </span>
            <div className="mx-3 h-6 w-[1px] rotate-[15deg] bg-white/10"></div>
            <span className="text-[24px] font-normal text-white drop-shadow-[0_0_8px_rgba(255,255,255,0.15)]">
              PORTAL
            </span>
          </div>
          <div className="mt-3 h-[1px] w-full bg-gradient-to-r from-transparent via-white/10 to-transparent"></div>
        </div>
        <p className="mt-4 text-[7px] font-light uppercase tracking-[0.5em] text-white/50">
          Unified Systems Environment
        </p>
      </div>

      {/* خط فاصل */}
      <div className="mb-7 h-px bg-white/5" />

      {/* روابط القائمة */}
      <nav className="custom-scrollbar relative z-[120] mb-auto overflow-y-auto overflow-x-hidden px-4 pt-1">
        <ul className="flex flex-col gap-1">
          <Links
            routes={routes}
            permissions={userPermissions}
            role={userRole}
          />
        </ul>
      </nav>

      {/* System Status */}
      <div className="relative z-10 mt-6 flex justify-center px-6">
        <div className="w-full rounded-xl border border-white/5 bg-white/[0.02] p-4 backdrop-blur-md">
          <p className="text-center text-[9px] font-light uppercase tracking-[0.3em] text-gray-400">
            System <span className="text-white/70">Active</span>
          </p>
          <div className="mt-3 h-[1px] w-full overflow-hidden rounded-full bg-white/5">
            <div className="h-full w-1/3 animate-[shimmer_2s_infinite] bg-core-accent/30"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
